"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_query_1 = require("@tanstack/react-query");
var networking_1 = require("../networking");
var types_1 = require("../types");
var utils_1 = require("../helpers/utils");
var signalr_1 = require("../signalr");
var useReserveMet_1 = __importDefault(require("./useReserveMet"));
var useConfigureCounter_1 = require("./useConfigureCounter");
var useHandleBiddingTable_1 = require("./useHandleBiddingTable");
var useHandleBiddingTableWithSignalR_1 = require("./useHandleBiddingTableWithSignalR");
var useSoldBanner_1 = __importDefault(require("./useSoldBanner"));
var useParticipateStatus_1 = __importDefault(require("./useParticipateStatus"));
var useFinalizing_1 = __importDefault(require("./useFinalizing"));
var useBidding = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var auctionId = _a.auctionId, lotId = _a.lotId, profileId = _a.profileId, currentDateTimeOffset = _a.currentDateTimeOffset, lotName = _a.locales.lotName, onScrollToTop = _a.onScrollToTop;
    //CLIENTS
    var queryClient = (0, react_query_1.useQueryClient)();
    //NETWORK STATES
    var _q = (0, networking_1.useHandleLoadAuctionById)(auctionId), auctionData = _q.data, auctionDataError = _q.error, auctionDataIsFetching = _q.isLoading, auctionIsFetched = _q.isFetched, auctionDataRefetching = _q.isRefetching;
    var _r = (0, networking_1.useRetrieveBiddingPageData)({ auctionId: auctionId, lotId: lotId, profileId: profileId }), biddingData = _r.data, biddingDataError = _r.error, biddingDataIsFetching = _r.isLoading, biddingDataIsFetched = _r.isFetched, biddingDataRefetching = _r.isRefetching, biddingDataUpdatedAt = _r.dataUpdatedAt;
    var _s = (0, useHandleBiddingTableWithSignalR_1.useHandleBiddingTableWithSignalR)({
        auctionId: auctionId,
        lotId: lotId,
        currentUserProfileId: profileId,
    }), tableRowData = _s.tableRowData, topBidder = _s.topBidder, setTableRowData = _s.setTableRowData;
    var _t = (0, useParticipateStatus_1.default)({ profileId: profileId, auctionId: auctionId }), participateStatus = _t.participateStatus, invalidateParticipateStatus = _t.invalidateParticipateStatus, participateStatusError = _t.participateStatusError, participateStatusLoading = _t.loading;
    //LOCAL STATES
    var _u = (0, react_1.useState)((0, utils_1.getNewDateWithOffset)(currentDateTimeOffset)), now = _u[0], setNow = _u[1];
    var _v = (0, react_1.useState)(0), maximumBidAmount = _v[0], setMaximumBidAmount = _v[1];
    var _w = (0, react_1.useState)(0), tenderAmount = _w[0], setTenderAmount = _w[1];
    var _x = (0, react_1.useState)(""), paddleNumber = _x[0], setPaddleNumber = _x[1];
    var _y = (0, react_1.useState)(0), increment = _y[0], setIncrement = _y[1];
    var _z = (0, react_1.useState)(null), incrementTable = _z[0], setIncrementTable = _z[1];
    var _0 = (0, react_1.useState)(), locked = _0[0], setLocked = _0[1];
    var _1 = (0, react_1.useState)(0), startingPrice = _1[0], setStartingPrice = _1[1];
    var _2 = (0, react_1.useState)(0), reservePrice = _2[0], setReservePrice = _2[1];
    var _3 = (0, react_1.useReducer)(function (state, action) {
        if (action > state || !state)
            return action;
        return state;
    }, undefined), extendedBy = _3[0], setExtendedBy = _3[1];
    var _4 = (0, react_1.useState)(), refreshLotStatusAt = _4[0], setRefreshLotStatusAt = _4[1];
    var _5 = (0, react_1.useState)(), start = _5[0], setStart = _5[1];
    var _6 = (0, react_1.useState)(), end = _6[0], setEnd = _6[1];
    var countDownTimer = (0, useConfigureCounter_1.useConfigureCounter)({
        start: start,
        end: end,
    });
    var winningProfileId = (0, react_1.useRef)((_b = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _b === void 0 ? void 0 : _b.winningRegisteredProfileId);
    var reserveMet = (0, useReserveMet_1.default)(biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot, topBidder === null || topBidder === void 0 ? void 0 : topBidder.amount, reservePrice);
    var soldBanner = (0, useSoldBanner_1.default)({
        sold: (_d = (_c = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _c === void 0 ? void 0 : _c.sold) !== null && _d !== void 0 ? _d : false,
        stcStatus: (_f = (_e = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _e === void 0 ? void 0 : _e.stcStatus) !== null && _f !== void 0 ? _f : 0,
        winningBidAmount: topBidder === null || topBidder === void 0 ? void 0 : topBidder.amount,
        isReserveMet: reserveMet,
        timerStatus: countDownTimer === null || countDownTimer === void 0 ? void 0 : countDownTimer.status,
        shortBanner: false,
    });
    var _7 = (0, useFinalizing_1.default)({
        auctionType: auctionData === null || auctionData === void 0 ? void 0 : auctionData.auctionType,
        lotLocale: lotName,
    }), finalizingText = _7.finalizingText, setValidating = _7.setValidating, validating = _7.validating;
    var isTender = (0, react_1.useMemo)(function () { return (auctionData === null || auctionData === void 0 ? void 0 : auctionData.auctionType) && Number(auctionData.auctionType) === Number(types_1.AuctionTypeEnum.Tender.toString()); }, [auctionData === null || auctionData === void 0 ? void 0 : auctionData.auctionType]);
    var minimumIncrement = (0, react_1.useMemo)(function () {
        var newIncrement = increment;
        if (incrementTable) {
            var incrementNotUsedBool_1 = true;
            var incrementNotUsed_1 = 0;
            var incrementTableparamData = (0, utils_1.JsonCheck)(incrementTable);
            incrementTableparamData === null || incrementTableparamData === void 0 ? void 0 : incrementTableparamData.increments.map(function (incrementRow) {
                if (topBidder.amount >= Number(incrementRow === null || incrementRow === void 0 ? void 0 : incrementRow.fromAmount) && topBidder.amount <= Number(incrementRow === null || incrementRow === void 0 ? void 0 : incrementRow.toAmount)) {
                    newIncrement = Number(incrementRow === null || incrementRow === void 0 ? void 0 : incrementRow.increment);
                    incrementNotUsedBool_1 = false;
                }
                else {
                    incrementNotUsed_1 = Number(incrementRow === null || incrementRow === void 0 ? void 0 : incrementRow.increment);
                }
            });
            //This is used incase the last increment table result is not met it must keep using that increment
            if (incrementNotUsedBool_1) {
                newIncrement = incrementNotUsed_1;
            }
        }
        return newIncrement;
    }, [incrementTable, increment, topBidder.amount]);
    //FUNCTIONS
    var invalidateAuction = (0, react_1.useCallback)(function () {
        queryClient.invalidateQueries([types_1.CacheKeys.auction, auctionId]);
    }, [auctionId, queryClient]);
    var invalidateBiddingData = (0, react_1.useCallback)(function () {
        queryClient.invalidateQueries([types_1.CacheKeys.biddingData, { auctionId: auctionId, lotId: lotId }]);
    }, [auctionId, lotId, queryClient]);
    var refresh = (0, react_1.useCallback)(function () {
        invalidateAuction();
        invalidateBiddingData();
    }, [invalidateAuction, invalidateBiddingData]);
    var handleBidSubmittedSuccess = (0, react_1.useCallback)(function (amount, paddleNumber) {
        setTableRowData({
            type: useHandleBiddingTable_1.BidTableAction.Upsert,
            data: {
                amount: amount,
                paddleNumber: paddleNumber,
            },
        });
    }, [setTableRowData]);
    var handleMaxBidSubmittedSuccess = (0, react_1.useCallback)(function (amount) {
        setMaximumBidAmount(amount);
    }, [setMaximumBidAmount]);
    var handleTenderSubmittedSuccess = (0, react_1.useCallback)(function (amount) {
        setTenderAmount(amount);
    }, [setTenderAmount]);
    //SIDE_EFFECTS
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        if (!biddingData)
            return;
        setMaximumBidAmount((_b = (_a = biddingData === null || biddingData === void 0 ? void 0 : biddingData.maximumBid) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : 0);
        setStartingPrice((_d = (_c = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _c === void 0 ? void 0 : _c.startingPrice) !== null && _d !== void 0 ? _d : 0);
        setReservePrice((_f = (_e = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _e === void 0 ? void 0 : _e.reservePrice) !== null && _f !== void 0 ? _f : 0);
        setIncrement((_g = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _g === void 0 ? void 0 : _g.defaultMinimumIncrement);
        setIncrementTable((_h = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _h === void 0 ? void 0 : _h.incrementTable);
        setExtendedBy(Number((_k = (_j = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _j === void 0 ? void 0 : _j.extendedBy) !== null && _k !== void 0 ? _k : 0));
        setPaddleNumber((_m = (_l = biddingData === null || biddingData === void 0 ? void 0 : biddingData.registeredProfile) === null || _l === void 0 ? void 0 : _l.paddleNumber) !== null && _m !== void 0 ? _m : "");
        setTenderAmount((_q = (_p = (_o = biddingData === null || biddingData === void 0 ? void 0 : biddingData.bids) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.amount) !== null && _q !== void 0 ? _q : 0);
    }, [biddingData]);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        if ((auctionData === null || auctionData === void 0 ? void 0 : auctionData.startDateTimeAt) && ((_a = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _a === void 0 ? void 0 : _a.endDateTimeAt)) {
            setNow((0, utils_1.getNewDateWithOffset)(currentDateTimeOffset));
            setStart(new Date(auctionData === null || auctionData === void 0 ? void 0 : auctionData.startDateTimeAt));
            var endDate = new Date((_b = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _b === void 0 ? void 0 : _b.endDateTimeAt);
            endDate.setSeconds(endDate.getSeconds() + (extendedBy !== null && extendedBy !== void 0 ? extendedBy : Number((_d = (_c = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _c === void 0 ? void 0 : _c.extendedBy) !== null && _d !== void 0 ? _d : 0)));
            setEnd(endDate);
        }
    }, [auctionData === null || auctionData === void 0 ? void 0 : auctionData.startDateTimeAt, (_g = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _g === void 0 ? void 0 : _g.endDateTimeAt, (_h = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _h === void 0 ? void 0 : _h.extendedBy, extendedBy, countDownTimer === null || countDownTimer === void 0 ? void 0 : countDownTimer.status, currentDateTimeOffset]);
    (0, react_1.useEffect)(function () {
        var _a;
        winningProfileId.current = (_a = tableRowData === null || tableRowData === void 0 ? void 0 : tableRowData[0]) === null || _a === void 0 ? void 0 : _a.registeredProfileId;
    }, [tableRowData]);
    (0, react_1.useEffect)(function () {
        var callbackId = (0, signalr_1.onReceiveMessage)(function (message) {
            if (message) {
                var payload = JSON.parse(message);
                if (payload.auctionId === auctionId && profileId === payload.profileId) {
                    if (payload.messageSubject === types_1.MessageSubject.AuctionDatesUpdated) {
                        invalidateAuction();
                        invalidateBiddingData();
                    }
                }
                if (payload === null || payload === void 0 ? void 0 : payload.data) {
                    var _a = payload.data, messageSubject = _a.messageSubject, entityId = _a.entityId, // lotId - lock/release of this lot has taken place
                    notificationLotId = _a.lotId, notificationProfileId = _a.profileId, extendedBy_1 = _a.extendedBy, increment_1 = _a.increment, notificationAuctionId = _a.auctionId, amount = _a.amount, notificationTopBidder = _a.topBidder, notificationMessage = _a.message, bidAmount = _a.bidAmount, // bid amount updated for specific lot,
                    deleted = _a.deleted, // bid deleted from specific lot
                    bidId = _a.bidId, startingPrice_1 = _a.startingPrice, reservePrice_1 = _a.reservePrice;
                    var notificationReservePrice = Number(reservePrice_1);
                    var isNotificationThisLot = entityId === lotId || notificationLotId === lotId;
                    var isNotificationThisAuction = notificationAuctionId === auctionId;
                    var isExtendedBy = extendedBy_1 !== "" && extendedBy_1 !== undefined;
                    var hasNewIncrement = increment_1 !== undefined && increment_1 !== "";
                    var mayAddBid = amount !== undefined && amount !== "" && notificationTopBidder !== undefined && notificationTopBidder !== "";
                    try {
                        //Guard to ensure that the notification is for this auction
                        if (!isNotificationThisAuction)
                            return;
                        if (messageSubject === types_1.MessageSubject.UpdateRegisteredProfile && notificationProfileId === profileId) {
                            invalidateParticipateStatus();
                        }
                        //Gaurd to ensure that the notification is for this lot
                        if (!isNotificationThisLot)
                            return;
                        if (messageSubject === types_1.MessageSubject.CreateBid) {
                            if (mayAddBid) {
                                setTableRowData({
                                    type: useHandleBiddingTable_1.BidTableAction.Upsert,
                                    data: {
                                        bidId: bidId,
                                        amount: amount,
                                        paddleNumber: notificationTopBidder,
                                        profileId: payload.data.profileId,
                                        registeredProfileId: payload.data.registeredProfileId,
                                    },
                                });
                            }
                            if (isExtendedBy) {
                                setExtendedBy(Number(extendedBy_1));
                                setRefreshLotStatusAt(undefined);
                            }
                            onScrollToTop();
                        }
                        if (messageSubject === types_1.MessageSubject.BidUpdated) {
                            if (deleted) {
                                setTableRowData({
                                    type: useHandleBiddingTable_1.BidTableAction.RemoveBid,
                                    data: {
                                        bidId: bidId,
                                    },
                                });
                            }
                            if (bidAmount) {
                                setTableRowData({
                                    type: useHandleBiddingTable_1.BidTableAction.UpdateBidAmount,
                                    data: {
                                        bidId: bidId,
                                        amount: bidAmount,
                                    },
                                });
                            }
                        }
                        if (messageSubject === types_1.MessageSubject.EntityLocked) {
                            setLocked({
                                isLocked: true,
                                message: notificationMessage,
                            });
                        }
                        if (messageSubject === types_1.MessageSubject.EntityReleased) {
                            setLocked({
                                isLocked: false,
                                message: notificationMessage,
                            });
                        }
                        if (messageSubject === types_1.MessageSubject.UpdateLotIncrement) {
                            if (hasNewIncrement)
                                setIncrementTable(null);
                            setIncrement(increment_1);
                        }
                        if (messageSubject === types_1.MessageSubject.UpdatedStartPrice) {
                            setStartingPrice(startingPrice_1);
                        }
                        if (messageSubject === types_1.MessageSubject.UpdatedReservePrice) {
                            setReservePrice(notificationReservePrice);
                        }
                        if (messageSubject === types_1.MessageSubject.ManuallyExtendedLot) {
                            setExtendedBy(Number(extendedBy_1));
                            setRefreshLotStatusAt(undefined);
                        }
                    }
                    catch (e) {
                        //TODO: may handle this error in the future
                    }
                }
            }
        });
        return function () { return (0, signalr_1.clearOnReceiveMessage)(callbackId); };
    }, [auctionId, lotId, onScrollToTop, profileId, setTableRowData, invalidateParticipateStatus, invalidateAuction, invalidateBiddingData]);
    var _8 = (0, networking_1.useValidateLotIsOpen)({
        pathParams: {
            auctionId: auctionId,
            lotId: lotId,
        },
        refreshAt: profileId ? refreshLotStatusAt : undefined,
    }, {
        retry: true,
        retryDelay: function (failedCount) { return (failedCount < 3 ? failedCount * 1000 : 3000); },
    }), lotStatus = _8.data, lotStatusFetching = _8.isFetching, lotStatusRefetching = _8.isRefetching, lotStatusFetched = _8.isFetched, lotStatusSucess = _8.isSuccess, lotStatusQueryKey = _8.generatedQueryKey, lotStatusFailureCount = _8.failureCount;
    (0, react_1.useEffect)(function () {
        return function () {
            setRefreshLotStatusAt(undefined);
            setValidating(false);
            setExtendedBy(0);
        };
    }, [auctionId, lotId]);
    (0, react_1.useEffect)(function () {
        if (lotStatusSucess && lotStatusFetched && !lotStatusRefetching && !lotStatusFetching && refreshLotStatusAt) {
            queryClient.invalidateQueries({
                queryKey: lotStatusQueryKey,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshLotStatusAt]);
    (0, react_1.useEffect)(function () {
        if (lotStatusSucess && lotStatusFetched && !lotStatusRefetching && !lotStatusFetching && lotStatus) {
            if (lotStatus.isOpen || (lotStatus.winningProfileId && winningProfileId.current !== lotStatus.winningProfileId)) {
                invalidateBiddingData();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lotStatusFetching, lotStatusRefetching, lotStatusFetched, lotStatus]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (countDownTimer.previousStatus !== undefined && (countDownTimer === null || countDownTimer === void 0 ? void 0 : countDownTimer.status) === types_1.LotStatus.COMPLETED && !((_a = biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) === null || _a === void 0 ? void 0 : _a.sold)) {
            setValidating(true);
            profileId ? setTimeout(function () { return setRefreshLotStatusAt(new Date().getTime()); }, 1000) : setTimeout(function () { return setValidating(false); }, 2000);
        }
    }, [countDownTimer === null || countDownTimer === void 0 ? void 0 : countDownTimer.status]);
    (0, react_1.useEffect)(function () {
        if (biddingDataUpdatedAt && (biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot)) {
            setTimeout(function () {
                setValidating(false);
            }, 1000);
        }
    }, [biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot, biddingDataUpdatedAt]);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        if (biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot) {
            var winningRegisteredProfileAmount = biddingData.lot.winningRegisteredProfileAmount;
            var winningBidAmount = winningRegisteredProfileAmount;
            if (((_a = tableRowData === null || tableRowData === void 0 ? void 0 : tableRowData[0]) === null || _a === void 0 ? void 0 : _a.amount) && ((_b = tableRowData === null || tableRowData === void 0 ? void 0 : tableRowData[0]) === null || _b === void 0 ? void 0 : _b.amount) !== winningBidAmount) {
                winningBidAmount = (_c = tableRowData === null || tableRowData === void 0 ? void 0 : tableRowData[0]) === null || _c === void 0 ? void 0 : _c.amount;
            }
            setTimeout(function () {
                setValidating(false);
            }, 1000);
        }
    }, [biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot, tableRowData, lotStatus]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (biddingData && participateStatus && !((_a = biddingData.registeredProfile) === null || _a === void 0 ? void 0 : _a.paddleNumber) && participateStatus.status === 1)
            invalidateBiddingData();
    }, [participateStatus]);
    //DERIVED STATES
    var loading = auctionDataIsFetching || biddingDataIsFetching;
    var refreshing = auctionDataRefetching || biddingDataRefetching;
    var loadingRegisteredProfile = !!profileId && participateStatusLoading;
    var dataIsLoaded = auctionIsFetched && biddingDataIsFetched;
    var error = (_l = (_k = (_j = auctionDataError === null || auctionDataError === void 0 ? void 0 : auctionDataError.message) !== null && _j !== void 0 ? _j : biddingDataError === null || biddingDataError === void 0 ? void 0 : biddingDataError.message) !== null && _k !== void 0 ? _k : participateStatusError === null || participateStatusError === void 0 ? void 0 : participateStatusError.message) !== null && _l !== void 0 ? _l : null;
    var registrationStatus = profileId ? (_m = participateStatus === null || participateStatus === void 0 ? void 0 : participateStatus.status) !== null && _m !== void 0 ? _m : 0 : 0;
    var lockedText = locked
        ? locked.isLocked === true
            ? (_o = locked.message) !== null && _o !== void 0 ? _o : "".concat(isTender ? "Tendering" : "Bidding", " currently locked on this ").concat(lotName.toLowerCase(), ". Temporary lock will be lifted in a few moments. Please stay tuned.")
            : null
        : null;
    var unlockedText = locked
        ? locked.isLocked === false
            ? (_p = locked.message) !== null && _p !== void 0 ? _p : "".concat(isTender ? "Tendering" : "Bidding", " on this ").concat(lotName.toLowerCase(), " is now unlocked. You can now resume ").concat(isTender ? "tendering" : "bidding", ".")
            : null
        : null;
    return {
        auction: auctionData,
        lot: biddingData === null || biddingData === void 0 ? void 0 : biddingData.lot,
        now: now,
        maximumBidAmount: maximumBidAmount,
        tenderAmount: tenderAmount,
        paddleNumber: paddleNumber,
        participateStatus: participateStatus,
        registrationStatus: registrationStatus,
        soldBanner: soldBanner,
        locked: locked,
        startingPrice: startingPrice,
        reservePrice: reservePrice,
        validating: validating,
        countDownTimer: countDownTimer,
        winningProfileId: winningProfileId,
        topBidder: topBidder,
        reserveMet: reserveMet,
        minimumIncrement: minimumIncrement,
        loading: loading,
        refreshing: refreshing,
        dataIsLoaded: dataIsLoaded,
        finalizingText: finalizingText,
        lockedText: lockedText,
        unlockedText: unlockedText,
        refresh: refresh,
        invalidateAuction: invalidateAuction,
        invalidateBiddingData: invalidateBiddingData,
        invalidateParticipateStatus: invalidateParticipateStatus,
        handleBidSubmittedSuccess: handleBidSubmittedSuccess,
        handleMaxBidSubmittedSuccess: handleMaxBidSubmittedSuccess,
        handleTenderSubmittedSuccess: handleTenderSubmittedSuccess,
        lotStatusFailureCount: lotStatusFailureCount,
        error: error,
        loadingRegisteredProfile: loadingRegisteredProfile,
        start: start,
        end: end,
        tableRowData: tableRowData,
        isExtended: extendedBy > 0,
    };
};
exports.default = useBidding;
